function Footer() {

    return (<div className="h-[20vh] flex">
        <span className="mt-auto p-5">
            © Matthew Swann 2021 - 2025
        </span>
    </div>);
}

export default Footer;